import axiosInstance from "../axiosInstance"

// Secondary Fund deals — served by portal-backend GET /secondary/deals from
// the secondary_deal Airtable mirror. Legs per deal type:
//   Exercise Into Purchase → exercise + liquidity legs (two wires)
//   everything else        → one purchase leg (= Transaction Amount)
// The exercise leg is simply absent for deals that don't require exercise —
// the UI hides it by key presence, no flag juggling.

export interface SecondaryLeg {
  amount: number | null       // Airtable's amount for the leg
  totalSet: number | null     // the deliberately-set, Airtable-verified total (null = not set)
  sentAmount: number          // staged + sent + released so far
  remaining: number | null    // totalSet − sentAmount (null until total set)
  paid: boolean
  paidDate: string | null
}

export interface SecondaryDeal {
  dealId: string
  company: string | null
  dealType: string | null
  requiresExercise: boolean
  fundType: string | null
  closingDate: string | null
  shareCount: number | null
  pps: number | null
  totalDealSize: number | null
  legs: {
    exercise?: SecondaryLeg
    liquidity?: SecondaryLeg
    purchase?: SecondaryLeg
  }
  syncedAt: string
}

export interface SecondaryDealsResponse {
  deals: SecondaryDeal[]
  syncStale: boolean
}

export const getSecondaryDeals = async (email?: string): Promise<SecondaryDealsResponse> => {
  const response = await axiosInstance.get("/secondary/deals", {
    params: email ? { email } : undefined,
  })
  return response.data
}
